import { GenericObj } from '@utils/functions';
import { StaticValues } from '@utils/enums/StaticValues.enum';
import { CustomFields } from '@utils/interfaces';
import {
  CustomInsuranceField,
  CustomInsuranceFieldsFormData,
} from './CustomInsuranceFieldsForm.interface';

export const CUSTOM_INSURANCE_FIELD_MAX_LENGTH = 300;

export const getCustomInsuranceFieldKey = (index: number) =>
  `field${index + 1}`;

export const getVisibleCustomInsuranceFields = (
  customFields?: CustomFields,
): CustomInsuranceField[] => {
  if (!customFields?.show || !customFields.children?.length) return [];

  return customFields.children.reduce<CustomInsuranceField[]>(
    (fields, field, index) => {
      if (field.status === StaticValues.FIELD_STATUS_HIDDEN) return fields;

      fields.push({
        fieldKey: getCustomInsuranceFieldKey(index),
        label: field.labelTextOnly || field.label,
        required: field.status === StaticValues.FIELD_STATUS_MANDATORY,
      });

      return fields;
    },
    [],
  );
};

export const hasVisibleCustomInsuranceFields = (customFields?: CustomFields) =>
  getVisibleCustomInsuranceFields(customFields).length > 0;

export const toCustomInsuranceDefaultValues = (
  customFields?: CustomFields,
  initialValues?: GenericObj,
): CustomInsuranceFieldsFormData => {
  const storeCustomFieldsInsurance = getVisibleCustomInsuranceFields(
    customFields,
  ).reduce((values, field) => {
    values[field.fieldKey] = initialValues?.[field.fieldKey] || '';
    return values;
  }, {} as GenericObj);

  return {
    patientDetails: {
      storeCustomFieldsInsurance,
    },
  };
};
